import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar/NavBar';
import Footer from '../components/Footer/Footer';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleReturnToHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div style={{ background: '#18191A', minHeight: '100vh', color: '#fff', fontFamily: 'inherit' }}>
      <NavBar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <div style={{ textAlign: 'center', maxWidth: '600px', padding: '20px' }}>
          {/* 404 图标 */}
          <div style={{ fontSize: '120px', marginBottom: '24px', fontWeight: 'bold', color: '#667eea' }}>
            404
          </div>
          
          {/* 标题 */}
          <h1 style={{ fontSize: '32px', marginBottom: '16px', color: '#fff' }}>
            Page Not Found
          </h1>
          
          {/* 描述 */}
          <p style={{ fontSize: '18px', marginBottom: '32px', color: '#ccc' }}>
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>
          
          {/* 信息卡片 */}
          <div style={{ 
            background: '#2a2a2a', 
            padding: '16px', 
            borderRadius: '8px', 
            marginBottom: '32px',
            border: '1px solid #444'
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#fff' }}>
              💡 What can you do?
            </h3>
            <ul style={{ 
              margin: '0', 
              paddingLeft: '20px', 
              textAlign: 'left', 
              fontSize: '14px', 
              color: '#ccc' 
            }}>
              <li style={{ marginBottom: '8px' }}>Check the URL for typos</li>
              <li style={{ marginBottom: '8px' }}>Go back to the previous page</li>
              <li style={{ marginBottom: '8px' }}>Return to the homepage</li>
            </ul>
          </div>

          {/* 操作按钮 */}
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button 
              onClick={handleGoBack}
              style={{
                padding: '12px 24px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Go Back
            </button>
            <button 
              onClick={handleReturnToHome}
              style={{
                padding: '12px 24px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Return to Homepage
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
